<template>
  <div class="z-card amount-card spacer-bottom-l">
    <div class="z-title z-title--larger">
      {{ currentContract.remaining_value | formatCurrency }}
    </div>
    <div class="z-caption">
      Valor total em aberto do seu {{ periodName }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
.amount-card {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['currentContract']),
    periodName() {
      return this.currentContract.period_name;
    },
  },
};
</script>
